import { useEffect } from "react";
import { useStore } from "@nanostores/react";
import "./App.css";
import { store } from "./stores/s3";
import {
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Stack,
  Container,
  Tfoot,
  Link
} from "@chakra-ui/react";

const generatePrefix = (prefix: string) => {
  let parts = prefix.split("/");
  if (parts[1].length === 0) {
    return ""
  }
  console.log(parts);
  return parts.slice(0, parts.length - 2).join("/") + "/"
}

function App() {
  const query = new URLSearchParams(window.location.search);
  const prefix = query.get("prefix") || "";
  console.log(prefix.split("/"))
  const { objects, files, folders } = useStore(store.state);
  useEffect(() => {
    store.actions.getObjects({ prefix });
  }, []);

  return (
    <Container py="8" flex="1">
      <Stack spacing={{ base: "8", lg: "6" }}>
        <Box bg="biege" borderRadius="lg">
          <Stack spacing="5" padding="5">
            <TableContainer>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Size</Th>
                    <Th>Last Modified</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {prefix.length > 0 ? (
                    <Tr>
                      <Td><Link href={`?prefix=${generatePrefix(prefix)}`}>..</Link></Td>
                      <Td></Td>
                      <Td></Td>
                    </Tr>
                  ) : null}
                  {objects.map((x) => (
                    <Tr key={x.name}>
                      <Td>{x.type == "folder" ? <Link href={`?prefix=${x.name}`}>{x.name}</Link> : <Link href={`${window.location.origin}/${x.name}`}>{x.name}</Link> }</Td>
                      <Td>{x.size}</Td>
                      <Td>{x.lastModified}</Td>
                    </Tr>
                  ))}
                </Tbody>
                <Tfoot>
                  <Tr>
                    <Td>{`${files} Files, ${folders} Folders`}</Td>
                    <Td></Td>
                    <Td></Td>
                  </Tr>
                </Tfoot>
              </Table>
            </TableContainer>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}

export default App;
